// extracted by mini-css-extract-plugin
module.exports = {"socials_wrapper":"SocialLinks_socials_wrapper__1dvCg","social_item":"SocialLinks_social_item__1_pd7","icon":"SocialLinks_icon__ggPFG"};